<template>
  <el-dialog
    :model-value="visible"
    :title="title"
    draggable
    width="700px"
    top="5vh"
    @update:model-value="handleClose"
  >
    <el-form ref="elFormRef" :model="projectForm" label-position="top">
      <!-- <el-form-item label="项目类型" required prop="type">
        <el-radio-group v-model="projectForm.type" :disabled="isEdit">
          <el-radio-button label="build">构建项目</el-radio-button>
          <el-radio-button label="image">镜像项目</el-radio-button>
        </el-radio-group>
      </el-form-item> -->

      <el-form-item label="项目名称"  prop="name" :rules="[{ required: true, message: '请输入项目名称', trigger: 'blur' }]">
        <el-input v-model="projectForm.name" placeholder="请输入项目名称" />
      </el-form-item>

      <!-- 镜像项目特有字段 -->
      <template v-if="projectForm.type === 'image'">
        <el-form-item label="镜像地址" prop="image" :rules="[{ required: true, message: '请输入镜像地址', trigger: 'blur' }]">
          <el-input
            v-model="projectForm.image"
            placeholder="例如: redis:7.2.12"
          />
        </el-form-item>

        <el-form-item label="辅助参数">
          <template #label>
            辅助参数：
            <el-button
              type="primary"
              :icon="Plus"
              size="small"
              @click="extraParams.push({ key: '', value: '' })"
              >添加参数</el-button
            >
          </template>
          <div
            v-for="(item, index) in extraParams"
            :key="index"
            class="flex items-center mb-[4px]"
          >
            <el-input
              v-model="item.key"
              size="small"
              placeholder="Key"
              class="flex-1"
            />
            <el-divider direction="vertical" />
            <el-input
              v-model="item.value"
              size="small"
              placeholder="Value"
              class="flex-1"
            />
            <el-divider direction="vertical" />
            <el-button
              type="danger"
              size="small"
              :icon="Delete"
              :disabled="item.key === 'password'"
              @click="extraParams.splice(index, 1)"
            />
          </div>
        </el-form-item>
      </template>

      <!-- 构建项目特有字段 -->
      <template v-else>
        <el-form-item
          label="Git仓库地址"
          prop="detail.gitRepo"
          required
          :rules="[{ validator: validateGitRepo, trigger: 'blur' }]"
        >
          <el-input
            v-model="projectForm.detail!.gitRepo"
            placeholder="git@..."
          />
        </el-form-item>
        <div class="flex space-x-4">
          <el-form-item label="分支" class="flex-1">
            <el-input
              v-model="projectForm.detail!.branch"
              placeholder="分支名称"
            />
          </el-form-item>
          <el-form-item label="构建目录" class="flex-1" prop="detail.buildDir" :rules="[{ required: true, message: '请输入构建目录', trigger: 'blur' }]">
            <el-input
              v-model="projectForm.detail!.buildDir"
              placeholder="例如: /server"
            />
          </el-form-item>
        </div>

        <el-form-item label="依赖项目">
          <template #label>
            依赖项目：
            <el-button
              type="primary"
              :icon="Plus"
              size="small"
              @click="addDependency"
              >添加依赖</el-button
            >
          </template>
          <div
            v-for="(dep, idx) in projectForm.depends"
            :key="idx"
            class="w-full flex items-center mb-[4px]"
          >
            <el-input
              v-model="dep.gitRepo"
              placeholder="Git地址"
              class="flex-1"
              size="small"
            ></el-input>
            <!-- <el-divider direction="vertical" />
            <el-input
              v-model="dep.branch"
              placeholder="分支"
              size="small"
            ></el-input> -->
            <el-divider direction="vertical" />
            <el-button
              type="danger"
              :icon="Delete"
              size="small"
              @click="projectForm.depends?.splice(idx, 1)"
            ></el-button>
          </div>
        </el-form-item>
      </template>

      <!-- 公共字段 -->
      <el-form-item label="端口映射" class="flex-1" :rules="[{ validator: validatePortMaps, trigger: 'blur' }]">
        <template #label>
          端口映射：
          <el-button
            type="primary"
            :icon="Plus"
            size="small"
            @click="
              projectForm.portMaps.push({ hostPort: undefined, containerPort: undefined })
            "
            >添加</el-button
          >
        </template>
        <div
          v-for="(pm, idx) in projectForm.portMaps"
          :key="idx"
          class="flex items-center mb-[4px]"
        >
          <el-input
            v-model.number="pm.hostPort"
            placeholder="主机端口"
            size="small"
          />
          <el-divider direction="vertical" />
          <el-input
            v-model.number="pm.containerPort"
            placeholder="容器端口"
            size="small"
          />
          <el-divider direction="vertical" />
          <el-button
            type="danger"
            :icon="Delete"
            size="small"
            @click="projectForm.portMaps.splice(idx, 1)"
          ></el-button>
        </div>
      </el-form-item>

      <el-form-item label="卷映射" class="flex-1">
        <template #label>
          卷映射：
          <el-button
            type="primary"
            :icon="Plus"
            size="small"
            @click="
              projectForm.volumeMaps.push({ hostPath: '', containerPath: '' })
            "
            >添加</el-button
          >
        </template>
        <div
          v-for="(vm, idx) in projectForm.volumeMaps"
          :key="idx"
          class="flex items-center mb-[4px]"
        >
          <el-input v-model="vm.hostPath" placeholder="主机路径" size="small" />
          <el-divider direction="vertical" />
          <el-input
            v-model="vm.containerPath"
            placeholder="容器路径"
            size="small"
          />
          <el-divider direction="vertical" />
          <el-button
            type="danger"
            :icon="Delete"
            size="small"
            @click="projectForm.volumeMaps.splice(idx, 1)"
          ></el-button>
        </div>
      </el-form-item>
    </el-form>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitting">
          确定
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { ref, reactive, watch, computed } from "vue";
import { Plus, Delete } from "@element-plus/icons-vue";
import type { ProjectForm, Project } from "../types";
import { useProjects } from "../composables/useProjects";
import type { FormInstance } from "element-plus";

const props = defineProps<{
  visible: boolean;
  type: 'build' | 'image';
  envId: number;
  project?: Project | null;
}>();

const emit = defineEmits<{
  (e: "update:visible", visible: boolean): void;
  (e: "success"): void;
}>();

const isEdit = computed(() => !!props.project);

const title = computed(() => {
  let type = props.type === 'build' ? '构建' : '镜像';
  return isEdit.value ? `编辑${type}项目` : `新增${type}项目`;
});

const { createProject, updateProject, submitting } = useProjects();


interface ExtraParam {
  key: string;
  value: string;
}

const extraParams = ref<ExtraParam[]>([]);

const defaultForm: ProjectForm = {
  envID: 0,
  name: "",
  type: props.type,
  image: "",
  extra: {},
  detail: {
    gitRepo: "",
    branch: "",
    buildDir: "",
    runCmd: "",
  },
  depends: [],
  portMaps: [],
  volumeMaps: [],
};

const projectForm = reactive<ProjectForm>(
  JSON.parse(JSON.stringify(defaultForm)),
);

watch(
  () => props.visible,
  (val) => {
    if (val) {
      if (props.project) {
        const p = props.project;
        projectForm.envID = p.envID;
        projectForm.name = p.name;
        projectForm.type = p.type;
        projectForm.image = p.image || "";
        projectForm.detail = p.detail
          ? { ...p.detail }
          : { gitRepo: "", branch: "", buildDir: "" };
        projectForm.depends = p.depends ? [...p.depends] : [];
        projectForm.portMaps = p.portMaps ? [...p.portMaps] : [];
        projectForm.volumeMaps = p.volumeMaps ? [...p.volumeMaps] : [];

        extraParams.value = [];
        if (p.extra) {
          Object.entries(p.extra).forEach(([key, value]) => {
            extraParams.value.push({ key, value: String(value) });
          });
        }
      } else {
        Object.assign(projectForm, JSON.parse(JSON.stringify({...defaultForm, type: props.type})));
        projectForm.envID = props.envId;
        extraParams.value = [];
      }
    }
  },
);

const addDependency = () => {
  if (!projectForm.depends) projectForm.depends = [];
  projectForm.depends.push({ gitRepo: "", branch: "" });
};

const handleClose = () => {
  emit("update:visible", false);
};

const elFormRef = ref<FormInstance>();
const handleSubmit = async () => {
  const auth = await elFormRef.value?.validate();
  if (!auth) return;

  const extraObj: Record<string, any> = {};
  extraParams.value.forEach((p) => {
    if (p.key) extraObj[p.key] = p.value;
  });
  projectForm.extra = extraObj;

  let success = false;
  if (isEdit.value && props.project) {
    success = await updateProject({
      ...projectForm,
      id: props.project.id,
      envID: props.project.envID,
    });
  } else {
    projectForm.envID = props.envId;
    success = await createProject(projectForm);
  }

  if (success) {
    emit("success");
    handleClose();
  }
};

// git仓库校验函数，必须是git@开头的格式
const validateGitRepo = (rule: any, value: string, callback: any) => {
  if (!value) {
    callback(new Error("请输入Git仓库地址"));
  } else if (!/^git@/.test(value)) {
    callback(new Error("Git仓库地址必须以git@开头"));
  } else {
    callback();
  }
};

// 端口映射校验函数，至少映射一个端口
const validatePortMaps = (rule: any, value: any[], callback: any) => {
  if (value.length === 0) {
    callback(new Error("请至少映射一个端口"));
  } else {
    callback();
  }
};
</script>
